/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderAuthOptions, FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderAuthOptionsToJSON, } from './FxIdApplicationPublicDataBuilderAuthOptions';
export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(json)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseAuth.js.map